import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function (w: any, d: any, s: string, l: string, i: string) {
  w[l] = w[l] || [];
  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  const f = d.getElementsByTagName(s)[0];
  const j = d.createElement(s);
  const dl = l !== 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  if (f && f.parentNode) {
    f.parentNode.insertBefore(j, f);
  } else {
    d.head.appendChild(j);
  }
})(window, document, 'script', 'dataLayer', 'GTM-MJLLJMZD');
render(<App data-id="element-458" data-mp="2k1h0by9kl94r" />, document.getElementById('root'));